import { render, staticRenderFns } from "./textBgWave.vue?vue&type=template&id=5271a638&scoped=true&"
import script from "./textBgWave.vue?vue&type=script&lang=js&"
export * from "./textBgWave.vue?vue&type=script&lang=js&"
import style0 from "./textBgWave.vue?vue&type=style&index=0&id=5271a638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271a638",
  null
  
)

export default component.exports